import { Root } from "./style";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  "aria-label"?: string;
}

const SIZES: Record<NonNullable<SpinnerProps["size"]>, number> = {
  sm: 24,
  md: 42,
  lg: 56,
};

export const Spinner = ({ size = "md", "aria-label": ariaLabel = "Carregando" }: SpinnerProps) => {
  return <Root $size={SIZES[size]} role="status" aria-label={ariaLabel} />;
};
